import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { getErrorMessages } from '../../utils';
import { TFreelancerData, TPageNotification } from '../../types';
import { executeHttpRequest } from '../../epics/api';


type TFreelancerSettings = {
    sms_preference: string;  // eslint-disable-line camelcase
}

const defaultSettings: TFreelancerSettings = {
    sms_preference: null,
};

type TFreelancerDetailsSettingsProps = {
    freelancerData: TFreelancerData;
    notification: TPageNotification;
};

export default function FreelancerDetailsSettings({
    freelancerData,
    notification,
}: TFreelancerDetailsSettingsProps) {
    const [settings, setSettings] = useState(defaultSettings);
    const [smsPreferenceOptions, setSmsPreferenceOptions] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const getSmsPreferenceOptions = () =>
        executeHttpRequest('freelancers/sms-preference-choices/', 'get')
            .then(response => setSmsPreferenceOptions(response.data.content))
            .catch(err => console.log(err));  // eslint-disable-line no-console

    const setSettingsState = (data: TFreelancerSettings) =>
        setSettings({
            sms_preference: data.sms_preference,
        });

    const getSettings = () => {
        setIsLoading(true);
        executeHttpRequest(`freelancers/${freelancerData.id}/settings/`, 'get')
            .then(response => {
                setIsLoading(false);
                setSettingsState(response.data.content);
            })
            .catch(err => {
                setIsLoading(false);
                console.log(err);  // eslint-disable-line no-console
            });
    };

    const updateSettings = (data: TFreelancerSettings) => {
        setIsLoading(true);
        setError(null);
        executeHttpRequest(`freelancers/${freelancerData.id}/settings/`, 'patch', data)
            .then(response => {
                setIsLoading(false);
                setSettingsState(response.data.content);
                notification.success('Success', 'Worker settings updated successfully');
            })
            .catch(err => {
                setIsLoading(false);
                setError(getErrorMessages(err));
            });
    };

    useEffect(() => {
        getSmsPreferenceOptions();
    }, []);

    useEffect(() => {
        getSettings();
    }, [freelancerData.is_active, freelancerData.is_unsuitable]);

    return (
            <div className="freelancer-details-section">
                <div className="freelancer-details-section__header">
                    <div className="freelancer-details-section__title">
                        Settings
                    </div>
                </div>
                {error && (
                    <div className="freelancer-details-section__errors">
                        <p>{error}</p>
                    </div>
                )}
                <div className="freelancer-details-section__content">
                    <table className="table-default">
                        <tbody>
                            <tr>
                                <td className="table-default__cell--text-blue">
                                    SMS Preference
                                </td>
                                <td>
                                    <Select
                                        options={smsPreferenceOptions}
                                        // @ts-ignore
                                        value={settings.sms_preference}
                                        onChange={e => updateSettings({ sms_preference: e.value })}
                                        clearable={false}
                                        disabled={isLoading || !smsPreferenceOptions}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
}
